<template>
  <portal to="modalsnew" v-if="open">
    <modal-component
      :show="open"
      @close="close"
      container-classes="max-w-content-xl my-12.5 md:my-0"
      wrapper-classes="flex"
      :show-close-button="false"
    >
      <div class="flex newsformpop justify-center w-full">
        <div class="p-5 bg-blue-dark text-white rounded w-full max-w-screen-sm relative">
          <button
            @click.prevent.stop="close"
            class="modal-close-button text-white absolute z-10 top-0 right-0 h-12.5 w-12.5 lg:h-15 lg:w-15"
          ></button>

          <h2 class="text-3xl text-center font-primary font-extrabold mb-4">Seeking a path less travelled?</h2>
          <p class="prose mb-5 text-center">
            Sign up for a monthly summary of our best recommendations.
          </p>
          <newsletter-form></newsletter-form>
        </div>
      </div>
    </modal-component>
  </portal>
</template>

<script>
import ModalComponent from './ModalComponent.vue';

export default {
  components: { ModalComponent },

  data() {
    return {
      open: false,
      seen: localStorage.getItem('newsletter-popup-seen') === 'true',
    };
  },

  created() {
    if (!this.seen) {
      window.setTimeout(() => {
        this.open = true;
      }, 20000);
    }
  },

  methods: {
    show() {
      this.open = true;
    },

    close() {
      localStorage.setItem('newsletter-popup-seen', 'true');
      this.open = false;
      this.seen = true;
    },
  },
};
</script>
